import { render } from "./wrongAnswersBoard.vue?vue&type=template&id=42b96829&scoped=true"
import script from "./wrongAnswersBoard.vue?vue&type=script&lang=js"
export * from "./wrongAnswersBoard.vue?vue&type=script&lang=js"

import "./wrongAnswersBoard.vue?vue&type=style&index=0&id=42b96829&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42b96829"]])

export default __exports__